import axios from 'axios'
import { createPrefix } from 'utils/create-prefix'

export class DisposableTokensService {
  constructor() {
    this.endpoints = createPrefix('/tokens/disposable', {
      base: '/',
      exchange: '/exchange',
    })
  }

  static create() {
    return new DisposableTokensService()
  }

  async getTempToken() {
    const servicePath = this.endpoints.base()
    const {
      data: { token },
    } = await axios.post(servicePath)
    return token
  }

  async getToken(token, nonce) {
    const servicePath = this.endpoints.exchange()
    const { data } = await axios.put(servicePath, { token, nonce })
    return data
  }
}
